import script from "./TemplatesResults.vue?vue&type=script&setup=true&lang=js"
export * from "./TemplatesResults.vue?vue&type=script&setup=true&lang=js"

import "./TemplatesResults.vue?vue&type=style&index=0&id=5106b445&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5106b445"]])

export default __exports__